<template>
  <div v-role="roles">
    <div>
      <div class="formPosition">
        <v-overlay :value="overlay">
          <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>

        <template>
          <v-form ref="form" v-model="formValid" lazy-validation>
            <v-container class="text-md-left">
              <v-row no-gutters>
                <v-col md="12">
                  <v-card>
                    <v-list flat>
                      <v-header>
                        <v-row>
                          <v-col md="12">
                            <v-row>
                              <v-col md="6">
                                <v-card-title
                                  >Lançamento de notas anteriores Finalista -
                                  {{
                                    objAnolectivo !== null
                                      ? objAnolectivo.novadescricao
                                      : ""
                                  }}</v-card-title
                                >
                              </v-col>
                              <v-col md="5" v-if="!$store.state.hasMessage">
                              </v-col>
                              <v-col md="5" v-if="$store.state.hasMessage">
                                <div
                                  :style="estiloPauta"
                                  v-if="$store.state.hasMessage"
                                  :class="$store.state.classMessage"
                                >
                                  {{ $store.state.textMessage }}
                                </div>
                              </v-col>
                            </v-row>
                            <v-card-text>
                              <v-row>
                                <v-col md="4">
                                  <v-combobox
                                    :items="classes"
                                    v-model="classeSelected"
                                    item-text="descricao"
                                    label="Selecionar a classe"
                                    return-object
                                    @change="filtrarTurmas()"
                                    placeholder="Selecione a classe"
                                  >
                                  </v-combobox>
                                </v-col>
                                <v-col md="4">
                                  <v-combobox
                                    :items="turmasFilter"
                                    v-model="turmaSelected"
                                    item-text="descricao"
                                    label="Selecionar a Turma"
                                    @change="findDisciplinaInProfDisc()"
                                    placeholder="Selecione a turma"
                                  >
                                  </v-combobox>
                                </v-col>
                                <v-col md="4">
                                  <v-combobox
                                    :items="disciplinas"
                                    v-model="disciplinaSelected"
                                    @change="pautaByTurma()"
                                    item-text="descricao"
                                    label="Selecionar a Disciplina"
                                    placeholder="Selecione a disciplina"
                                    return-object
                                  >
                                  </v-combobox>
                                </v-col>
                              </v-row>
                            </v-card-text>
                          </v-col>
                        </v-row>
                      </v-header>

                      <v-list-item-group
                        v-model="item"
                        color="primary"
                        style="width: 100%"
                      >
                        <!--  Nota Finalista  header -->
                        <v-row
                          style="
                            background-color: #ccc;
                            margin-left: 0px;
                            width: 100%;
                          "
                          v-if="listEstudantfromPauta.length"
                        >
                          <v-col cols="12" sm="12" md="1"></v-col>
                          <v-col cols="12" sm="12" md="1">N.</v-col>
                          <v-col cols="12" sm="12" md="7">Nome</v-col>

                          <v-col cols="12" sm="12" md="1">Nota</v-col>

                          <v-col cols="12" sm="12" md="1">Action</v-col>
                          <v-col cols="12" sm="12" md="1">Autor</v-col>
                        </v-row>

                        <hr v-if="listEstudantfromPauta.length" />
                        <br />

                        <!-- end  list  header  -->

                        <v-list-item
                          v-for="(item, i) in listEstudantfromPauta"
                          :key="i"
                        >
                          <v-list-item-icon>
                            <v-icon v-text="item.icon"></v-icon>
                          </v-list-item-icon>
                          <!-- body 1  trimestre -->

                          <v-row class="bodyLancamentoNotas">
                            <v-col cols="12" sm="12" md="1">
                              <img
                                class="photomouse"
                                :src="getPhoto(item)"
                                alt="avatar"
                                width="30px;"
                              />
                            </v-col>
                            <v-col cols="12" sm="12" md="1">{{ i + 1 }}.</v-col>

                            <v-col cols="12" sm="12" md="7">
                              <v-list-item-title
                                v-text="item.nome"
                              ></v-list-item-title>
                            </v-col>

                            <v-col cols="12" sm="12" md="1">
                              <p
                                v-if="editedpk !== item.pkpauta"
                                class="text-lowercase"
                              >
                                {{ item.p1_MD }}
                              </p>
                              <v-text-field
                                v-if="editedpk === item.pkpauta"
                                :rules="notaRules"
                                v-model="editedItem.p1_MD"
                                single-line
                              ></v-text-field>
                            </v-col>

                            <v-col cols="12" sm="12" md="1">
                              <v-btn
                                color="secondary"
                                fab
                                x-small
                                dark
                                :disabled="btn_activacao1"
                                v-if="editedpk !== item.pkpauta"
                                class="mr-2"
                                @click="bt_edit(item)"
                              >
                                <v-icon>edit</v-icon>
                              </v-btn>

                              <v-btn
                                color="primary"
                                fab
                                x-small
                                dark
                                v-if="editedpk === item.pkpauta"
                                @click="bt_save(editedItem)"
                              >
                                <v-icon>save_alt</v-icon>
                              </v-btn>
                            </v-col>
                            <v-col cols="12" sm="12" md="1">
                              <span style="font-size: 8px"
                                >{{ item.autor }}--{{ item.data_2 }}</span
                              >
                            </v-col>
                          </v-row>
                        </v-list-item>
                      </v-list-item-group>
                    </v-list>
                  </v-card>
                </v-col>
              </v-row>
            </v-container>
          </v-form>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "../../../plugins/axios";
import photostudent from "../../../utilitarios/photo.services";
import Swal from "sweetalert2";
const ls = require("local-storage");
export default {
  data: () => ({
    roles: "prof",
    estiloPauta: "position:fixed;background-color:green;color:white;",
    formValid: true,
    on: false,
    notaRules: [
      // this.value.replace(/[^\d]/, ''),
      (v) => (v >= 0 && v <= 20) || "nota invalida",
      (v) => !isNaN(v) || "not number ",
      (value) => {
        const pattern = /^[+-]?\d+(\.\d+)?$/;
        return pattern.test(value) || "Invalido.";
      },
      (v) => v.length <= 4 || "valor inválido",
    ],
    text: "",
    editedpk: false,
    profediscinas: [],
    role_usuario: "",
    disciplinas: [],
    progresso_2: false,
    _classe: "",
    Professor: "",
    dialog: false,
    overlay: false,
    objAnolectivo: null,
    dialogoDisabilita: false,
    idanoacademico: 0,
    offset: true,
    descricao_Prof: "",
    tumaSelect: "",
    progresso_3: false,
    iddisciplina: 0,
    btn_description: "",
    publicar_status: false,
    idturma: 0,
    closeOnClick: true,
    progresso: true,
    classes: [{ id: 4, descricao: "13ª classe" }],
    classeSelected: null,
    disciplinaSelected: null,
    turmaSelected: null,
    disciplinaSelected: null,
    turmasFilter: [],
    item: 1,
    listaPautasBloquadas: [],
    btn_activacao1: false,
    btn_activacao2: false,
    btn_activacao3: false,
    listaDeClassesPorLancarNotas: [],
    listEstudantfromPauta: [],
    editedIndex: -1,
    editedItem: {
      pkpauta: 0,
      p1_notaMac: 0,
      p1_nota: 0,
      p1_nota2: 0,
      p1_MD: 0,
      p2_notaMac: 0,
      p2_nota: 0,
      p2_nota2: 0,
      p2_MD: 0,
      p3_notaMac: 0,
      p3_nota: 0,
      p3_MD: 0,
      pg: 0,
      ca: 0,
      mfd: 0,
    },
  }),
  computed: {
    idclasse() {
      return this.$store.state.idclasse;
    },
    role() {
      return ls.get("role");
    },
  },

  watch: {
    listaDeClassesPorLancarNotas() {
      this.$store.state.isloading = false;
    },
  },
  created() {
    if (ls.get("role") === "ROLE_COOR") {
      this.roles = "coor";
    }
    if (this.$store.state.anolectivoLancamento === null) {
      this.$router.push("menu");
    }
    this.objAnolectivo = this.$store.state.anolectivoLancamento;
    this.turmaFindWithEstudanteCount("all");
    // this.CarregaPautas()
    this.initprofdisc();
    this.role_usuario = ls.get("role");
  },

  methods: {
    classe(idanoacademico) {
      if (idanoacademico === 1) {
        this._classe = "10ª Classe";
      }
      if (idanoacademico === 2) {
        this._classe = "11ª Classe";
      }
      if (idanoacademico === 3) {
        this._classe = "12ª Classe";
      }
      if (idanoacademico === 4) {
        this._classe = "13ª Classe";
      }

      this.idanoacademico = idanoacademico;
    },
    loadprogressbar() {
      this.$store.state.isloading = true;
    },

    bt_edit(item) {
      this.editedIndex = this.listEstudantfromPauta.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.editedpk = item.pkpauta;
      console.log(item.pkpauta);
      this.editedItem.trimestre = this.$store.state.idperfilpauta;
      this.editedItem.pkpauta = item.pkpauta;
      setTimeout(() => {}, 1000);
    },
    MostrarDialogo() {
      this.dialog = true;
    },

    MostrarDialogoDisabilitar() {
      this.dialogoDisabilita = true;
    },
    bt_save(editedItem) {
      // this.editedIndex = this.listEstudantfromPauta.indexOf(item)
      // this.editedItem = Object.assign({}, item)
      if (this.formValid) {
        this.save(editedItem);
        this.editedpk = 0;
      }
      setTimeout(() => {}, 1000);
    },
    backTodisciplinList() {
      this.listEstudantfromPauta = [];
    },
    backToTurmaList() {
      this.disciplinas = [];
    },

    filtrarTurmas() {
      this.overlay = true;
      this.turmasFilter = [];
      this.disciplinas = [];
      this.listEstudantfromPauta = [];
      this.disciplinaSelected = null;
      this.turmaSelected = null;
      this.turmasFilter = this.listaDeClassesPorLancarNotas.filter(
        (t) => t.idAno_Academico === this.classeSelected.id
      );
      this.overlay = false;
    },

    async turmaFindWithEstudanteCount(idclasse) {
      this.progresso = true;
      try {
        this.progresso = true;
        this.listaDeClassesPorLancarNotas = await axios
          .get(
            "/turmaFindWithEstudanteCount/" +
              "all/" +
              this.objAnolectivo.descricao
          ) // idclasse JyUn JQ==
          .then((res) => res.data);
        this.progresso = false;
      } catch (error) {
        // this.isLoading = false
        this.progresso = false;
        // this.text = error
        this.$store.dispatch("textMessage", {
          msg: error,
          classMessage: "msgError",
          timeout: 3000,
        });
      }
      this.listEstudantfromPauta = [];
    },
    async save(editedItem) {
      if (this.role === "ROLE_ADM") {
        this.estiloPauta = "position:fixed;background-color:red;color:white;";
        this.$store.dispatch("textMessage", {
          msg: "Não é permitido ao administrador Lançar Notas ou altera-las.",
          classMessage: "msgError",
          timeout: 8000,
        });
      } else {
        var params = {
          nota: editedItem.p1_MD,
          pkpauta: editedItem.pkpauta,
          anolectivo: this.objAnolectivo.descricao
        };
        try {
          // eslint-disable-next-line no-unused-vars
          let valor = await axios

            .post("/lancarNotaFinalista-admin", params)
            .then((res) => res.data);
          this.text = "Nota Inserida com sucesso!";
          this.$store.dispatch("textMessage", {
            msg: this.text,
            classMessage: "msgSucess",
            timeout: 8000,
          });
          this.listEstudantfromPauta[this.editedIndex].p1_MD =
            this.editedItem.p1_MD;
        } catch (error) {
          // this.isLoading = false

          // this.text = error
          this.$store.dispatch("textMessage", {
            msg: error,
            classMessage: "msgError",
            timeout: 3000,
          });
        }
      }
    },

    async pautaByTurma() {
      // carrega turma apartir de bauta  Turma
      let obj = this.disciplinaSelected;
      this.$store.state.disciplina = obj.iddisciplina;
      this.$store.state.objDisciplina = obj;
      const payload =
        '{"iddisciplina":"' +
        obj.iddisciplina +
        '" , "pkturma":"' +
        obj.pkturma +
        '", "i_id":"' +
        ls.get("i_id") +
        '"  }';

      try {
        this.progresso_3 = true;
        this.listEstudantfromPauta = await axios

          .get("/listEstudantfromPauta/" + payload)
          .then((res) => res.data);

        this.progresso_3 = false;
        this.MostraProfessor();
      } catch (error) {
        // this.isLoading = false
        this.progresso_3 = false;
        // this.text = error
        this.$store.dispatch("textMessage", {
          msg: error,
          classMessage: "msgError",
          timeout: 3000,
        });
      }
    },

    async initprofdisc(search) {
      let payload;
      try {
        if (!search) {
          payload = '{"find":"all"}';
        } else {
          payload = '{"find":"' + search + '"}';
        }
        this.profediscinas = await axios
          .get("/professordiscFindAll/" + payload)
          .then((res) => res.data);
      } catch (error) {
        this.isLoading = false;

        this.text = error;
        this.$store.dispatch("textMessage", {
          msg: this.text,
          classMessage: "msgError",
          timeout: 3000,
        });
      }
    },
    async PublicarPauta() {
      const valores = {
        turma:
          this.$store.state.objturma.descricao +
          "-" +
          this.$store.state.objturma.pkTurma,
        disciplina: this.$store.state.disciplina,
        trimestre: this.$store.state.lancarNotaDe,
        bloquear: 1,
        publicar: 1,
        idControlopauta: 0,
      };

      // Consumindo a API
      try {
        // eslint-disable-next-line no-unused-vars
        let valor = await axios

          .post("/bloquearPauta", valores)
          .then((res) => res.data);
        let text = "Pauta publicada com sucesso";
        this.$store.dispatch("textMessage", {
          msg: text,
          classMessage: "msgSucess",
          timeout: 8000,
        });
        this.dialog = false;

        this.$store.state.bloqueado.push(valores);
        // this.$store.state.bloqueado = []
        // CarregaPauta
        this.CarregaPautas();
        this.verificaPautas();
      } catch (error) {
        // this.isLoading = false

        // this.text = error
        this.$store.dispatch("textMessage", {
          msg: error,
          classMessage: "msgError",
          timeout: 3000,
        });
      }
    },

    async DesbloquearPauta() {
      // Verificando se o Id esta disponivel
      if (this.$store.state.Controlopauta != null) {
        // CONSUMINDO A API ----  Passando a Id
        const valores = {
          turma:
            this.$store.state.objturma.descricao +
            "-" +
            this.$store.state.objturma.pkTurma,
          disciplina: this.$store.state.disciplina,
          trimestre: this.$store.state.lancarNotaDe,
          bloquear: 0,
          publicar: 0,
          idControlopauta: this.$store.state.Controlopauta,
        };

        try {
          // eslint-disable-next-line no-unused-vars
          let valor = await axios

            .post("/bloquearPauta", valores)
            .then((res) => res.data);
          let text = "Pauta Bloqueada com sucesso";
          this.$store.dispatch("textMessage", {
            msg: text,
            classMessage: "msgSucess",
            timeout: 8000,
          });
          this.dialog = false;

          this.$store.state.bloqueado = [];
          // CarregaPauta
          this.CarregaPautas();
          this.verificaPautas();

          this.dialogoDisabilita = false;
        } catch (error) {
          // this.isLoading = false

          // this.text = error
          this.$store.dispatch("textMessage", {
            msg: error,
            classMessage: "msgError",
            timeout: 3000,
          });
        }
      }
    },

    MostraProfessor() {
      let valor = this.profediscinas.filter(
        (d) => d.iddisciplina === this.$store.state.disciplina
      );
      if (valor.length) {
        this.Professor = valor[0].nome;
        this.descricao_Prof = "disciplina atrbuida ao Professor";
      } else {
        this.Professor = "Sem Professor Associado";
        this.descricao_Prof = "";
      }
    },

    async CarregaPautas() {
      if (!this.$store.state.bloqueado.length) {
        try {
          this.$store.state.bloqueado = await axios

            .get("/ListarPautaBloqueada")
            .then((res) => res.data);
          console.log(this.$store.state.bloqueado);
        } catch (error) {
          // this.isLoading = false

          // this.text = error
          this.$store.dispatch("textMessage", {
            msg: error,
            classMessage: "msgError",
            timeout: 3000,
          });
        }
      }
    },

    HabilitaBotoes(valor) {
      if (
        this.listaPautasBloquadas.filter((t) => t.trimestre === "1º Trimestre")
      ) {
        this.btn_activacao1 = valor;
      }
      if (
        this.listaPautasBloquadas.filter((t) => t.trimestre === "2º Trimestre")
      ) {
        this.btn_activacao2 = valor;
      }
      if (
        this.listaPautasBloquadas.filter((t) => t.trimestre === "3º Trimestre")
      ) {
        this.btn_activacao3 = valor;
      }
    },

    verificaPautas() {
      this.listaPautasBloquadas = this.$store.state.bloqueado.filter(
        (block) =>
          block.turma ===
            this.$store.state.objturma.descricao +
              "-" +
              this.$store.state.objturma.pkTurma &&
          block.disciplina === this.$store.state.disciplina &&
          block.publicar === 1 &&
          block.bloquear === 1 &&
          block.trimestre === this.$store.state.lancarNotaDe
      );
      if (this.listaPautasBloquadas.length) {
        this.HabilitaBotoes(true);

        this.$store.state.Controlopauta =
          this.listaPautasBloquadas[0].idControlopauta;
        if (ls.get("role") === "ROLE_PROF") {
          this.publicar_status = true;
          this.btn_description = "Mini Pauta Bloqueada";
        } else {
          this.publicar_status = true;
          this.HabilitaBotoes(false);
          this.btn_description = "Mini Pauta Bloqueada";
        }
      } else {
        this.publicar_status = false;
        this.btn_description = "Bloquear";
        this.HabilitaBotoes(false);
      }
    },

    async findDisciplinaInProfDisc() {
      this.overlay = true;
      this.disciplinas = [];
      this.listEstudantfromPauta = [];
      this.disciplinaSelected = null;
      let obj = this.turmaSelected;
      this.disciplinas = [];
      this.$store.state.turma = obj.descricao;
      this.$store.state.objturma = obj;
      try {
        this.progresso_2 = true;
        this.disciplinas = await axios

          .get(
            "/findDisciplinaInProfDisc/" +
              obj.pkTurma +
              "/" +
              this.objAnolectivo.descricao
          )
          .then((res) => res.data);
        this.progresso_2 = false;
        this.overlay = false;
      } catch (error) {
        // this.isLoading = false
        this.progresso_2 = false;
        this.overlay = false;
        // this.text = error
        Swal.fire(
          "Informação",
          "Ocorreu um erro ao tentar efectuar a operação",
          "error"
        );
      }
    },
    getPhoto(item) {
      try {
        return photostudent.getPhotoStudent(item.matricula);
      } catch (error) {
        Swal.fire("Informação", "Ocorreu um erro ao carregar a foto", "error");
      }
    },
  },
};
</script>
